import React from 'react';

// Função auxiliar para verificar se todos os deadlines são "N.A." ou vazios
const allDeadlinesNA = (deadlines) => {
  return Object.values(deadlines).every(
    (val) => val === "N.A." || val === "" || val === null
  );
};

const ScheduleModal = ({ isOpen, data, loading, error, closeModal, params }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-auto"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white rounded-md max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-lg">
        <header className="flex justify-between items-center p-4 border-b border-gray-300">
          <h2 id="modal-title" className="text-lg font-semibold">
            Resultados de pesquisa de{" "}
            <strong>{params?.originCode || "Origem"}</strong> para{" "}
            <strong>{params?.destinationCode || "Destino"}</strong>
          </h2>
          <button
            onClick={closeModal}
            aria-label="Fechar modal"
            className="text-gray-600 hover:text-black focus:outline-none"
          >
            <i className="fas fa-times text-xl"></i>
          </button>
        </header>

        <div className="p-4">
          {loading && (
            <p className="text-center text-gray-700">Carregando dados...</p>
          )}
          {error && (
            <p className="text-center text-red-600 font-semibold">{error}</p>
          )}
          {!loading && !error && data.length === 0 && (
            <p className="text-center text-gray-700">Nenhum dado disponível.</p>
          )}

          {!loading &&
            !error &&
            data.length > 0 &&
            data.map((item, idx) => {
              const hideDeadlines = allDeadlinesNA(item.deadlines);
              return (
                <div
                  key={idx}
                  className="border border-gray-300 rounded-md mb-6"
                  aria-label={`Resultado ${idx + 1}`}
                >
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 border-b border-gray-300">
                    <div>
                      <div className="flex items-center space-x-2 mb-1 text-gray-600">
                        <i className="fas fa-map-marker-alt"></i>
                        <span>Partida</span>
                      </div>
                      <p className="font-bold text-gray-900">{item.departure.date}</p>
                      <p className="text-gray-700">{item.departure.location}</p>
                    </div>
                    <div>
                      <div className="flex items-center space-x-2 mb-1 text-gray-600">
                        <i className="fas fa-map-marker-alt"></i>
                        <span>Chegada</span>
                      </div>
                      <p className="font-bold text-gray-900">{item.arrival.date}</p>
                      <p className="text-gray-700">{item.arrival.location}</p>
                    </div>
                    <div>
                      <div className="flex items-center space-x-2 mb-1 text-gray-600">
                        <i className="fas fa-ship"></i>
                        <span>Navio/Viagem</span>
                      </div>
                      <p className="text-blue-700 font-semibold">{item.vessel.name}</p>
                      <p className="mb-0.5">{item.vessel.voyage}</p>
                      <p className="mb-1">
                        Tempo de viagem:{" "}
                        <span className="font-bold underline">{item.travelTime}</span>
                      </p>
                    </div>
                  </div>

                  {!hideDeadlines && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 border-b border-gray-300 text-xs text-gray-700">
                      <div>
                        <p>
                          CCT Cut off<br />
                          <span className="font-bold">{item.deadlines.cct}</span>
                        </p>
                      </div>
                      <div>
                        <p>
                          DCT Cut off<br />
                          <span className="font-bold">{item.deadlines.dct}</span>
                        </p>
                      </div>
                      <div>
                        <p>
                          VGM Cut off<br />
                          <span className="font-bold">{item.deadlines.vgmCct}</span>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ScheduleModal;
